import { CustomerActionTypes } from './constant';

interface CustomerInterface {
    id: number;
    name: string;
    email: string;
    role: string;
}

const INIT_STATE = {
    customers: [],
    loading: false,
    customerDetailsById: {},
    customerCreated: false,
    error: '',
    importLoading: false,
    importSuccess: false,
    importErrors: [] as string[],
    importProgress: 0,
};

type CustomerActionType = {
    type:
        | CustomerActionTypes.API_RESPONSE_SUCCESS
        | CustomerActionTypes.API_RESPONSE_ERROR
        | CustomerActionTypes.GET_CUSTOMERS
        | CustomerActionTypes.GET_CUSTOMER_DETAILS
        | CustomerActionTypes.UPDATE_CUSTOMER
        | CustomerActionTypes.ADD_CUSTOMER
        | CustomerActionTypes.DELETE_CUSTOMER
        | CustomerActionTypes.CLEAR_CUSTOMERS
        | CustomerActionTypes.BULK_IMPORT_CUSTOMERS
        | CustomerActionTypes.RESET_IMPORT_STATE
        | '@@customer/BULK_IMPORT_PROGRESS';
    payload: {
        actionType?: string;
        data?: CustomerInterface | {} | any;
        error?: string | string[];
        progress?: number;
    };
};

type State = {
    customers: CustomerInterface[]; // Use the appropriate type for your customer data
    customerDetailsById: {};
    loading?: boolean;
    customerCreated: boolean;
    error: string;
    importLoading: boolean;
    importSuccess: boolean;
    importErrors: string[];
    importProgress: number;
};

const Customer = (state: State = INIT_STATE, action: CustomerActionType) => {
    switch (action.type) {
        case CustomerActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CustomerActionTypes.GET_CUSTOMERS: {
                    return {
                        ...state,
                        customers: action.payload.data as CustomerInterface[],
                        customerCreated: false,
                        loading: false,
                    };
                }
                case CustomerActionTypes.GET_CUSTOMER_DETAILS: {
                    return {
                        ...state,
                        customerDetailsById: action.payload.data,
                        loading: false,
                    };
                }
                case CustomerActionTypes.UPDATE_CUSTOMER: {
                    return {
                        ...state,
                        customerDetailsById: action.payload.data,
                        loading: false,
                    };
                }
                case CustomerActionTypes.ADD_CUSTOMER: {
                    return {
                        ...state,
                        customerDetailsById: action.payload.data,
                        customerCreated: true,
                        loading: false,
                    };
                }
                case CustomerActionTypes.DELETE_CUSTOMER: {
                    return {
                        ...state,
                        loading: false,
                    };
                }
                case CustomerActionTypes.BULK_IMPORT_CUSTOMERS:
                    return {
                        ...state,
                        importLoading: false,
                        importSuccess: true,
                        importProgress: 100,
                        importErrors: [],
                    };
                case '@@customer/BULK_IMPORT_PROGRESS':
                    return {
                        ...state,
                        importProgress: action.payload.progress || 0,
                    };
                default:
                    return { ...state };
            }
        case CustomerActionTypes.API_RESPONSE_ERROR: {
            if (action.payload.actionType === CustomerActionTypes.BULK_IMPORT_CUSTOMERS) {
                return {
                    ...state,
                    importLoading: false,
                    importSuccess: false,
                    importErrors: Array.isArray(action.payload.error) ? action.payload.error : [action.payload.error as string || 'An error occurred'],
                };
            }
            switch (action.payload.actionType) {
                case CustomerActionTypes.GET_CUSTOMERS: {
                    return {
                        ...state,
                        error: action.payload.error || '', // Store the error message
                        loading: false,
                    };
                }
                case CustomerActionTypes.GET_CUSTOMER_DETAILS: {
                    return {
                        ...state,
                        error: action.payload.error || '',
                        loading: false,
                    };
                }
                case CustomerActionTypes.UPDATE_CUSTOMER: {
                    return {
                        ...state,
                        error: action.payload.error || '',
                        loading: false,
                    };
                }
                case CustomerActionTypes.ADD_CUSTOMER: {
                    return {
                        ...state,
                        error: action.payload.error || '',
                        loading: false,
                    };
                }
                case CustomerActionTypes.DELETE_CUSTOMER: {
                    return {
                        ...state,
                        error: action.payload.error || '',
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }
        }
        case CustomerActionTypes.GET_CUSTOMERS:
        case CustomerActionTypes.GET_CUSTOMER_DETAILS:
        case CustomerActionTypes.UPDATE_CUSTOMER:
        case CustomerActionTypes.ADD_CUSTOMER:
        case CustomerActionTypes.DELETE_CUSTOMER:
            return { ...state, loading: true };
        case CustomerActionTypes.CLEAR_CUSTOMERS: {
            return {
                ...state,
                customers: [],
                customerDetailsById: {},
                customerCreated: false,
            };
        }
        case CustomerActionTypes.BULK_IMPORT_CUSTOMERS:
            return {
                ...state,
                importLoading: true,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };
        case CustomerActionTypes.RESET_IMPORT_STATE:
            return {
                ...state,
                importLoading: false,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };
        default:
            return { ...state };
    }
};

export default Customer;
